var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"media_nav"},[_c('img',{staticClass:"menu_logo",attrs:{"src":require("./../../assets/daohang.png"),"alt":""},on:{"click":_vm.toggleClick}}),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$route.meta.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }